export default __webpack_public_path__ + "static/media/ic-community.ca5f5405.svg";